import { put, takeEvery, takeLatest, call } from '@redux-saga/core/effects';
import {
  get_profile_details,
  get_profile_details_success,
  get_profile_details_error,
  update_profile,
  update_profile_error,
  update_profile_success,
  change_password_error,
  change_password,
  get_orders,
  get_orders_success,
  get_orders_error,
  update_order_review,
  update_order_review_success,
  update_order_review_error,
  create_order_review,
  create_order_review_success,
  create_order_review_error,
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';
import axios from 'axios';

function* getProfileSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, '/users/whoami', payload);
    const responseData = requestRes.data;
    const response = responseData.data;

    yield put({
      type: get_profile_details_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_profile_details_error.type,
    });
  }
}

async function uploadImageToCloud(image) {
  try {
    const formdata = new FormData();
    const folder = process.env.REACT_APP_CLOUDINARY_FOLDER || '';
    const cloudinary_name = process.env.REACT_APP_CLOUDINARY_NAME || '';
    console.log(folder, cloudinary_name);
    formdata.append('upload_preset', folder);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    formdata.append('file', image);
    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${cloudinary_name}/image/upload`,
      formdata,
      config,
    );
    return res.data.secure_url;
  } catch (e) {
    console.log(e);
    toast.error(`{Something went wrong,please try again ...}`);
  }
}

function* updateProfileSaga({ payload }) {
  try {
    let pay_load = payload;
    if (payload.photo_url) {
      const imageUrl = yield uploadImageToCloud(payload.photo_url);
      pay_load = { ...payload, photo_url: imageUrl };
    }
    const requestRes = yield call(api.patch, '/users', pay_load);
    const responseData = requestRes.data;
    yield put({
      type: update_profile_success.type,
      payload: responseData.data,
    });
    toast.success(responseData.message);
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: update_profile_error.type,
    });
  }
}

function* changePasswordSaga({ payload }) {
  try {
    const requestRes = yield call(api.patch, '/auth/change-password', payload);
    const responseData = requestRes.data;
    if (responseData.success && responseData.status_code === 200) {
      toast.success('Password change successful, redirecting to login');
      localStorage.removeItem('x-access-token');
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    }
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: change_password_error.type,
    });
  }
}

function* getOrderSagas({ payload }) {
  try {
    const { page = 1, limit = 10, partner } = payload;
    const request = yield call(
      api.get,
      `orders/own?partner=${partner}&page=${page}&limit=${limit}`,
    );
    const responseData = request.data;
    const response = responseData.data;
    yield put({
      type: get_orders_success.type,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: get_orders_error.type,
    });
  }
}

function* updateOrderReviewSagas({ payload }) {
  try {
    const { id, data } = payload;
    const request = yield call(api.patch, `/order_reviews/${id}`, data);
    const response = request.data;
    console.log(response);
    yield put({
      type: update_order_review_success.type,
    });
  } catch (error) {
    const { response } = error;
    toast.error(response.data.message);
    yield put({
      type: update_order_review_error.type,
    });
  }
}

function* createOrderReviewSagas({ payload }) {
  try {
    const request = yield call(api.post, `order_reviews`, payload);
    const response = request.data;
    console.log(response);
    yield put({
      type: create_order_review_success.type,
    });
  } catch (error) {
    const { response } = error;
    toast.error(response.data.message);
    yield put({
      type: create_order_review_error.type,
    });
  }
}

function* profileSagas() {
  yield takeEvery(get_profile_details.type, getProfileSaga);
  yield takeLatest(update_profile.type, updateProfileSaga);
  yield takeLatest(change_password.type, changePasswordSaga);
  yield takeLatest(get_orders.type, getOrderSagas);
  yield takeLatest(update_order_review.type, updateOrderReviewSagas);
  yield takeLatest(create_order_review.type, createOrderReviewSagas);
}

export default profileSagas;
